import React, { useState } from 'react';

import { Tooltip, Typography } from '@mui/material';
import copy from 'copy-to-clipboard';
import EdiText from 'react-editext';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
// import { useENSName } from 'use-ens-name';

import { editFileAPI } from '@/api/editFileName';
import { PrimaryButton } from '@/components/Button/PrimaryButton';
import { isBrowser } from '@/constants/index';
import { sendNotifcation } from '@/utils/notification';
import { IAboutFileProps } from 'interfaces/PreviewScreen/previewScreen';
import CopyIcon from 'public/assets/CopyIcon.svg';
import TooltipImg from 'public/assets/tooltip.svg';

const AboutFile = ({
  file,
  fileName,
  setIsQrVisible,
  ipfsHash,
  canUserEdit,
  uuid,
  isEmbedFile,
  downloadable,
  isIpfsPreview,
}: IAboutFileProps) => {
  const currentURL = isBrowser
    ? `${window.location.origin}${window.location.pathname}`
    : '';
  const [copyURLVal, setURLCopyVal] = useState<string>('Copy');
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [copyIPFSVal, setIPFSCopyVal] = useState<string>('Copy');
  const urlParams = file?.data.url.split('?')[1];

  const [inputIPFS, setInputIPFS] = useState(ipfsHash);
  // const ensName = useENSName(file?.data?.owner?.address);
  let fileDisplayName = fileName;
  if (fileName.length > 15) {
    fileDisplayName = `${fileName.substring(0, 15)} ...`;
  }

  const inputValue = `${currentURL.substring(0, 32)} ...`;
  const copyToClipboard = (value: string | undefined) => {
    if (value) {
      copy(value);
      sendNotifcation('Copied to clipboard!', '', 'warning');
    }
  };
  const copyURLAnimation = () => {
    setURLCopyVal('Copied');
    setTimeout(() => {
      setURLCopyVal('Copy');
    }, 2000);
  };
  const copyIPFSAnimation = () => {
    setIPFSCopyVal('Copied');
    setTimeout(() => {
      setIPFSCopyVal('Copy');
    }, 2000);
  };
  const handleNameEdit = async (value: any) => {
    try {
      const recaptchaToken = await executeRecaptcha('edit');
      const resp = await editFileAPI(uuid, value, null, recaptchaToken);
      if (resp.status >= 200 && resp.status < 300) {
        sendNotifcation('File name updated!', '', 'warning');
      } else {
        sendNotifcation('Some error occured!', '', 'danger');
      }
    } catch (err) {
      sendNotifcation('Some error occured!', '', 'danger');
    }
  };

  return (
    <>
      <div className="p-4">
        <div className="flex items-center">
          <div>
            <h4 className="font-semibold flex items-center w-[70px]">Name :</h4>
          </div>

          {canUserEdit ? (
            <>
              <EdiText
                className="break-all"
                showButtonsOnHover
                value={fileName}
                type="text"
                onSave={handleNameEdit}
                submitOnUnfocus={false}
                submitOnEnter={true}
              />
            </>
          ) : (
            <p className="ml-2 flex items-center">{fileDisplayName}</p>
          )}
        </div>

        {/* {file.data.owner && (
          <div className=" ">
            <div className="font-semibold w-[80px]">Owner :</div>
            <div className="overflow-x-auto no-scrollbar truncate">
              {file.data.owner.username || ensName || file.data.owner.address}
            </div>
          </div>
        )} */}

        <div className="grid grid-cols-2 mt-4">
          <div className="flex items-center">
            <h4 className="mr-2 font-semibold">Shareable URL</h4>
            <Tooltip
              title="Copy the link to share your file. Don't forget to lock it if needed!"
              placement="top-start"
            >
              <img alt="" src={TooltipImg.src} />
            </Tooltip>
          </div>
          {!isIpfsPreview && (
            <div
              className="flex justify-end items-center"
              onClick={() => {
                setIsQrVisible(true);
              }}
            >
              <h4 className="mr-2 font-semibold cursor-pointer">
                Open QR Code
              </h4>
            </div>
          )}
        </div>
        <div className="w-full p-2 border border-[#DEDEDE] rounded-md mt-2 flex truncate">
          <input
            readOnly
            defaultValue={inputValue}
            onClick={() => copyToClipboard(currentURL)}
            className="w-[75%]"
          />
          <button
            onClick={() => {
              copyToClipboard(currentURL);
              copyURLAnimation();
            }}
            className="bg-black rounded-md flex ml-4 items-center justify-center p-1 w-[25%]"
          >
            <img src={CopyIcon.src} alt="copy icon" className="mr-1 w-4" />
            <Typography style={{ color: 'white' }}>{copyURLVal}</Typography>
          </button>
        </div>
        {!isEmbedFile && downloadable && (
          <>
            <div className="text-center my-4">Or</div>
            <div className="items-center flex flex-row justify-center">
              <PrimaryButton
                onClick={() => {
                  window.open(
                    `${process.env.NEXT_PUBLIC_API_URL}/content/${uuid}?${urlParams}&download=true`,
                    '_self'
                  );
                }}
              >
                <span>Download File</span>
              </PrimaryButton>
            </div>
            <div className="border mt-6" />
          </>
        )}
        <div className="flex mt-10">
          <h4 className="mr-2 font-semibold">IPFS Hash</h4>
          <Tooltip
            title="We store your encrypted files on a peer-to-peer network and file system called IPFS."
            placement="top-start"
          >
            <img alt="" src={TooltipImg.src} />
          </Tooltip>
        </div>
        <div className="w-full p-2 border border-[#DEDEDE] rounded-md mt-2 flex">
          <input
            readOnly
            defaultValue={ipfsHash}
            onClick={() => {
              copyToClipboard(inputIPFS);
            }}
            onChange={(e) => setInputIPFS(e.target.value)}
            className="w-[75%] "
          />
          <button
            onClick={() => {
              copyToClipboard(inputIPFS);
              copyIPFSAnimation();
            }}
            className="bg-black rounded-md flex ml-4 items-center justify-center p-1 w-[25%]"
          >
            <img src={CopyIcon.src} alt="copy icon" className="mr-1 w-4" />
            <Typography style={{ color: 'white' }}>{copyIPFSVal}</Typography>
          </button>
        </div>
      </div>
    </>
  );
};

export default AboutFile;
